import React from 'react';
import { TeamPickerView } from '@atlassian/jira-issue-field-team/src/ui/view-mode/index.tsx';

type Props = { team?: { name: string; id: string } | null };

export const TeamRead = ({ team }: Props) =>
	team ? <TeamPickerView defaultValue={team} placeholder="" isEditable={false} /> : null;
